import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { getToken, clearToken } from "../lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    const checkAuth = async () => {
      try {
        await axios.get(`${API}/auth/me`);
        setIsAuthenticated(true);
      } catch {
        clearToken();
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-slate-300 border-t-slate-900 rounded-full animate-spin" />
      </div>
    );
  }

  if (isAuthenticated === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
